<template>
  <ul class="sidebar">
    <li v-for="item in packageCate" :key="item.id">
      <a
        :href="'#pktitle' + item.id"
        :class="{ active: Active == 'pktitle' + item.id }"
      >
        {{ item.categoryName }}</a
      >
    </li>
    <li v-for="item in category" :key="item.id">
      <a
        :href="'#title' + item.id"
        :class="{ active: Active == 'title' + item.id }"
      >
        {{ item.categoryName }}</a
      >
    </li>

    <!-- <li>
      <a href="#title1" :class="{ active: this.Active == 'title1' }"
        >熱門組合</a
      >
    </li>

    <li>
      <a href="#title2" :class="{ active: this.Active == 'title2' }"
        >冷凍食品</a
      >
    </li>

    <li>
      <a href="#title3" :class="{ active: this.Active == 'title3' }"
        >飲料零食</a
      >
    </li> -->
  </ul>
</template>

<script>
export default {
  props: ['category', 'packageCate'],
  data() {
    return {
      now_read: '',
    };
  },
  computed: {
    now_hash() {
      return this.$store.state.hash;
    },
    Active() {
      return this.$store.state.active;
    },
  },
  mounted() {
    setTimeout(() => this.scrollFix(this.$route.hash), 1);
    this.scrollFix(this.$route.hash);
  },
  methods: {
    goTitle(id) {
      this.$store.commit('setHash', id);
    },
    scrollFix(hashbang) {
      this.goTitle(hashbang);
      // eslint-disable-next-line no-restricted-globals
      location.hash = hashbang;
    },
  },
  watch: {
    $route() {
      console.log(this.$route);
    },
  },
};
</script>

<style lang="scss">
</style>
